import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLiveVideoSetup } from '@rsos/live-video/shared/useLiveVideoSetup';
import { removeVideoSession, useVideoSessionFor } from '@rsos/reduxDataStore';
import {
  closeCard,
  LIVE_VIDEO_CARD,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import { useCurrentOrgName } from '@rsos/sinatra/src/selectors';
import { notifyInfo } from '@rsos/utils/toastUtils';
import useIsVT911CoreEnabled from '../../../../../hooks/useIsVT911CoreEnabled';

export function useVideoClosing(callerID: string, endChat: () => void) {
  const isVT911CoreEnabled = useIsVT911CoreEnabled();
  const videoSessionState = useVideoSessionFor(callerID);
  const orgName = useCurrentOrgName();

  const shouldCloseVideo = isVT911CoreEnabled && videoSessionState;

  const dispatch = useDispatch();
  const handleCardClosing = useCallback(
    () => dispatch(closeCard(LIVE_VIDEO_CARD)),
    [dispatch],
  );

  const { endRoom } = useLiveVideoSetup({
    callID: callerID,
    orgName,
  });

  const handleCallEnding = useCallback(async () => {
    const roomName = videoSessionState?.name;

    // At this point we should have the room name
    if (roomName) {
      await endRoom(roomName);
    }

    handleCardClosing();
    dispatch(removeVideoSession({ callID: callerID }));

    notifyInfo('Live video stream ended');
  }, [videoSessionState?.name, handleCardClosing, dispatch, callerID, endRoom]);

  const handleConfirm = () => {
    endChat();
    if (shouldCloseVideo) {
      handleCallEnding();
    }
  };

  return {
    handleConfirm,
    shouldCloseVideo,
  };
}
